import { useEffect, useState, useCallback } from 'react';

/**
 * Generic data-fetching hook.
 *  - fetcher: () => Promise<AxiosResponse>
 *  - deps: dependency array (re-fetches on change)
 */
export function useFetch(fetcher, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(() => {
    setLoading(true);
    return fetcher()
      .then((r) => { setData(r.data); setError(null); return r.data; })
      .catch((e) => { setError(e); throw e; })
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    fetcher().then((r) => {
      if (alive) { setData(r.data); setError(null); }
    }).catch((e) => { if (alive) setError(e); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);

  return { data, loading, error, reload };
}

export function Spinner({ label = 'Caricamento...' }) {
  return (
    <div className="flex items-center justify-center py-12 text-sm text-slate-400 gap-2">
      <div className="w-4 h-4 rounded-full border-2 border-[#023F80] border-t-transparent animate-spin" />
      {label}
    </div>
  );
}
